// import React, { useState } from "react";
// import { Button, Backdrop, CircularProgress } from "@mui/material";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { getSystemFormattedTimestamp } from "../../../utils/dateFormatted";
// import { logger } from "../../../utils/logger";
// import { useSelector } from "react-redux";

// const DonationPDF = ({ data, type }) => {
//   const [loading, setLoading] = useState(false);
//   const { user, role } = useSelector((state) => state.auth);
//   const PDFtype = type;
//   const BaseUrl = process.env.REACT_APP_BASE_URL;

//   const handleDownload = async () => {
//     setLoading(true);
//     try {
//       let response;

//       if (
//         PDFtype === "bookwise-paymodeall" ||
//         PDFtype === "bookwise-paymodewise"
//       ) {
//         response = await fetch(
//           `${BaseUrl}api/donationReport/download-book-paymode`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ data, type: PDFtype }),
//           }
//         );
//       } else if (PDFtype === "fundwise") {
//         response = await fetch(
//           `${BaseUrl}api/donationReport/download-fundwise`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ data, type: PDFtype }),
//           }
//         );
//       } else {
//         response = await fetch(`${BaseUrl}api/donationReport/download`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ data, type: PDFtype }),
//         });
//       }

//       if (!response.ok) {
//         let errorMsg = "Failed to generate PDF";
//         try {
//           const errorData = await response.json();
//           errorMsg = errorData.message || errorMsg;
//         } catch {}
//         throw new Error(errorMsg);
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `${PDFtype} ${getSystemFormattedTimestamp()}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//       logger.info("Donation Report PDF Downloaded Successfully", {
//         username: user?.username,
//         role: role,
//         filterType: PDFtype,
//         rowsCount: data?.report?.length || 0,
//       });
//     } catch (err) {
//       logger.error("Error downloading Donation Report PDF", {
//         username: user?.username,
//         role: role,
//         filterType: PDFtype,
//         rowsCount: data?.report?.length || 0,
//       });
//       console.error("Error downloading PDF:", err);
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Button variant="contained" onClick={handleDownload} color="primary">
//         <PictureAsPdfIcon style={{ marginRight: 8 }} />
//         Download
//       </Button>
//       <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
//         <CircularProgress color="inherit" />
//         <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
//       </Backdrop>
//     </>
//   );
// };

// export default DonationPDF;
// import React, { useState } from "react";
// import { Button, Backdrop, CircularProgress } from "@mui/material";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { getSystemFormattedTimestamp } from "../../../utils/dateFormatted";
// import { logger } from "../../../utils/logger";
// import { useSelector } from "react-redux";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import ExportFormatModal from "../../ExportFormatModal";

// const DonationPDF = ({ data, type }) => {
//   const [loading, setLoading] = useState(false);
//   const [exportModalOpen, setExportModalOpen] = useState(false);
//   const { user, role } = useSelector((state) => state.auth);
//   const PDFtype = type;
//   const BaseUrl = process.env.REACT_APP_BASE_URL;

//   const handleDownload = async () => {
//     setLoading(true);
//     try {
//       let response;
//       if (PDFtype === "bookwise-paymodeall" || PDFtype === "bookwise-paymodewise") {
//         response = await fetch(`${BaseUrl}api/donationReport/download-book-paymode`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ data, type: PDFtype }),
//         });
//       } else if (PDFtype === "fundwise") {
//         response = await fetch(`${BaseUrl}api/donationReport/download-fundwise`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ data, type: PDFtype }),
//         });
//       } else {
//         response = await fetch(`${BaseUrl}api/donationReport/download`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ data, type: PDFtype }),
//         });
//       }
//       if (!response.ok) {
//         let errorMsg = "Failed to generate PDF";
//         try {
//           const errorData = await response.json();
//           errorMsg = errorData.message || errorMsg;
//         } catch {}
//         throw new Error(errorMsg);
//       }
//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `${PDFtype} ${getSystemFormattedTimestamp()}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//       logger.info("Donation Report PDF Downloaded Successfully", {
//         username: user?.username,
//         role,
//         filterType: PDFtype,
//         rowsCount: data?.report?.length || 0,
//       });
//     } catch (err) {
//       logger.error("Error downloading Donation Report PDF", {
//         username: user?.username,
//         role,
//         filterType: PDFtype,
//         rowsCount: data?.report?.length || 0,
//       });
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleExcelDownload = () => {
//     const rows = data?.report || data || [];
//     if (!rows.length) return alert("No data to export");
//     const ws = XLSX.utils.json_to_sheet(rows);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "DonationReport");
//     const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(
//       new Blob([buf], { type: "application/octet-stream" }),
//       `${PDFtype}_${getSystemFormattedTimestamp()}.xlsx`
//     );
//   };

//   return (
//     <>
//       <Button variant="contained" onClick={() => setExportModalOpen(true)} color="primary">
//         <PictureAsPdfIcon style={{ marginRight: 8 }} />
//         Download
//       </Button>
//       <ExportFormatModal
//         open={exportModalOpen}
//         onClose={() => setExportModalOpen(false)}
//         onSelectPDF={handleDownload}
//         onSelectExcel={handleExcelDownload}
//       />
//       <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
//         <CircularProgress color="inherit" />
//         <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
//       </Backdrop>
//     </>
//   );
// };

// export default DonationPDF;


import React, { useState } from "react";
import { Button, Backdrop, CircularProgress } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { getSystemFormattedTimestamp } from "../../../utils/dateFormatted";
import { logger } from "../../../utils/logger";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";
import ExportFormatModal from "../../ExportFormatModal";

const DonationPDF = ({ data, type, reportFormat }) => {
  const [loading, setLoading] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const { user, role } = useSelector((state) => state.auth);
  const PDFtype = type;
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const handleDownload = async () => {
    setLoading(true);
    try {
      let response;
      // NEW: reportFormat sent in body so backend PDF grouping matches
      // whatever is shown on screen (year-grouped vs flat year-filtered)
      if (PDFtype === "bookwise-paymodeall" || PDFtype === "bookwise-paymodewise") {
        response = await fetch(`${BaseUrl}api/donationReport/download-book-paymode`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data, type: PDFtype, reportFormat }),
        });
      } else if (PDFtype === "fundwise") {
        response = await fetch(`${BaseUrl}api/donationReport/download-fundwise`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data, type: PDFtype, reportFormat }),
        });
      } else {
        response = await fetch(`${BaseUrl}api/donationReport/download`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data, type: PDFtype, reportFormat }),
        });
      }
      if (!response.ok) {
        let errorMsg = "Failed to generate PDF";
        try {
          const errorData = await response.json();
          errorMsg = errorData.message || errorMsg;
        } catch {}
        throw new Error(errorMsg);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${PDFtype} ${getSystemFormattedTimestamp()}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      logger.info("Donation Report PDF Downloaded Successfully", {
        username: user?.username,
        role,
        filterType: PDFtype,
        rowsCount: data?.report?.length || 0,
      });
    } catch (err) {
      logger.error("Error downloading Donation Report PDF", {
        username: user?.username,
        role,
        filterType: PDFtype,
        rowsCount: data?.report?.length || 0,
      });
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  // NEW: builds Excel rows that mirror exactly what's grouped/shown on
  // screen (DonationReportTable) — Receipt Date formatted, Year Total,
  // Book Total, Grand Total rows — instead of a raw JSON dump.
  const buildExcelRows = () => {
    const report = data?.report || [];
    const totals = data?.totals || {};
    const grandTotal = data?.grandTotal || 0;
    const fmtDate = (d) => (d ? moment(d).format("DD/MM/YYYY") : "");
    const fmtAmt = (n) => (n == null ? "" : Number(n));

    if (type === "bookwise") {
      const bookOrder = [];
      const bookGroups = {};
      report.forEach((item) => {
        const yr =
          item.receiptYear ??
          (item.receiptDate ? new Date(item.receiptDate).getFullYear() : "Unknown");
        if (!bookGroups[item.bookNo]) {
          bookGroups[item.bookNo] = {};
          bookOrder.push(item.bookNo);
        }
        if (!bookGroups[item.bookNo][yr]) bookGroups[item.bookNo][yr] = [];
        bookGroups[item.bookNo][yr].push(item);
      });

      const rows = [];
      const groupByYear = reportFormat !== "yearFilter";
      let sno = 1;

      bookOrder.forEach((bookNo) => {
        const yearGroups = bookGroups[bookNo];
        Object.keys(yearGroups)
          .sort((a, b) => Number(a) - Number(b))
          .forEach((yr) => {
            yearGroups[yr].forEach((item) => {
              rows.push({
                "S.No": sno++,
                "Book No": item.bookNo,
                "Receipt No": item.receiptNo,
                "Receipt Date": fmtDate(item.receiptDate),
                "Donor ID": item.donorId,
                "Donor Name": item.donorName,
                "Amount": fmtAmt(item.amount),
              });
            });
            if (groupByYear) {
              rows.push({
                "S.No": "",
                "Book No": `Year ${yr} Total`,
                "Receipt No": "",
                "Receipt Date": "",
                "Donor ID": "",
                "Donor Name": "",
                "Amount": fmtAmt(totals?.[bookNo]?.[yr] ?? 0),
              });
            }
          });
        rows.push({
          "S.No": "",
          "Book No": `Total for Book ${bookNo}`,
          "Receipt No": "",
          "Receipt Date": "",
          "Donor ID": "",
          "Donor Name": "",
          "Amount": fmtAmt(totals?.[bookNo]?.BookTotal ?? 0),
        });
      });
      rows.push({
        "S.No": "",
        "Book No": "Grand Total",
        "Receipt No": "",
        "Receipt Date": "",
        "Donor ID": "",
        "Donor Name": "",
        "Amount": fmtAmt(grandTotal),
      });
      return rows;
    }

    if (type === "bookwise-paymodeall" || type === "bookwise-paymodewise") {
      const bookOrder = [];
      const bookGroups = {};
      report.forEach((item) => {
        const yr =
          item.receiptYear ??
          (item.receiptDate ? new Date(item.receiptDate).getFullYear() : "Unknown");
        if (!bookGroups[item.bookNo]) {
          bookGroups[item.bookNo] = {};
          bookOrder.push(item.bookNo);
        }
        if (!bookGroups[item.bookNo][yr]) bookGroups[item.bookNo][yr] = {};
        if (!bookGroups[item.bookNo][yr][item.payMode]) {
          bookGroups[item.bookNo][yr][item.payMode] = [];
        }
        bookGroups[item.bookNo][yr][item.payMode].push(item);
      });

      const rows = [];
      const groupByYear = reportFormat !== "yearFilter";
      let sno = 1;

      bookOrder.forEach((bookNo) => {
        const yearGroups = bookGroups[bookNo];
        Object.keys(yearGroups)
          .sort((a, b) => Number(a) - Number(b))
          .forEach((yr) => {
            const payModeGroups = yearGroups[yr];
            Object.keys(payModeGroups).forEach((payMode) => {
              payModeGroups[payMode].forEach((item) => {
                rows.push({
                  "S.No": sno++,
                  "Book No": item.bookNo,
                  "Receipt No": item.receiptNo,
                  "Receipt Date": fmtDate(item.receiptDate),
                  "Pay Mode": item.payMode,
                  "Donor ID": item.donorId,
                  "Donor Name": item.donorName,
                  "Amount": fmtAmt(item.amount),
                });
              });
              rows.push({
                "S.No": "",
                "Book No": `Total for Book ${bookNo} (${payMode})`,
                "Receipt No": "",
                "Receipt Date": "",
                "Pay Mode": "",
                "Donor ID": "",
                "Donor Name": "",
                "Amount": fmtAmt(totals?.[bookNo]?.years?.[yr]?.[payMode] ?? 0),
              });
            });
            if (groupByYear) {
              rows.push({
                "S.No": "",
                "Book No": `Year ${yr} Total`,
                "Receipt No": "",
                "Receipt Date": "",
                "Pay Mode": "",
                "Donor ID": "",
                "Donor Name": "",
                "Amount": fmtAmt(totals?.[bookNo]?.years?.[yr]?.Total ?? 0),
              });
            }
          });
        rows.push({
          "S.No": "",
          "Book No": `Grand Total for Book ${bookNo}`,
          "Receipt No": "",
          "Receipt Date": "",
          "Pay Mode": "",
          "Donor ID": "",
          "Donor Name": "",
          "Amount": fmtAmt(totals?.[bookNo]?.BookTotal ?? 0),
        });
      });
      rows.push({
        "S.No": "",
        "Book No": "Grand Total",
        "Receipt No": "",
        "Receipt Date": "",
        "Pay Mode": "",
        "Donor ID": "",
        "Donor Name": "",
        "Amount": fmtAmt(grandTotal),
      });
      return rows;
    }

    if (type === "donorwise") {
      const grouped = {};
      report.forEach((item) => {
        if (!grouped[item.donorId]) grouped[item.donorId] = [];
        grouped[item.donorId].push(item);
      });
      const rows = [];
      let sno = 1;
      Object.entries(grouped).forEach(([donorId, entries]) => {
        entries.forEach((item) => {
          rows.push({
            "S.No": sno++,
            "Donor ID": item.donorId,
            "Donor Name": item.donorName,
            "City": item.city || "",
            "Receipt Date": fmtDate(item.receiptDate),
            "Book No": item.bookNo,
            "Receipt No": item.receiptNo,
            "Amount": fmtAmt(item.amount),
          });
        });
        rows.push({
          "S.No": "",
          "Donor ID": "",
          "Donor Name": "Total Amount",
          "City": "",
          "Receipt Date": "",
          "Book No": "",
          "Receipt No": "",
          "Amount": fmtAmt(totals?.[donorId] ?? 0),
        });
      });
      rows.push({
        "S.No": "",
        "Donor ID": "",
        "Donor Name": "Grand Total",
        "City": "",
        "Receipt Date": "",
        "Book No": "",
        "Receipt No": "",
        "Amount": fmtAmt(grandTotal),
      });
      return rows;
    }

    if (type === "fundwise") {
      const rows = [];
      let sno = 1;
      report.forEach((item) => {
        (item.details || []).forEach((detail) => {
          rows.push({
            "S.No": sno++,
            "Pay Purpose": item.payPurpose,
            "Pay Mode": detail.payMode,
            "Amount": fmtAmt(detail.totalAmount),
          });
        });
        rows.push({
          "S.No": "",
          "Pay Purpose": "",
          "Pay Mode": "Total",
          "Amount": fmtAmt(item.totalForPurpose),
        });
      });
      rows.push({
        "S.No": "",
        "Pay Purpose": "",
        "Pay Mode": "Grand Total",
        "Amount": fmtAmt(grandTotal),
      });
      return rows;
    }

    // Fallback — shouldn't normally hit this
    return report;
  };

  const handleExcelDownload = () => {
    const rows = buildExcelRows();
    if (!rows.length) return alert("No data to export");
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "DonationReport");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      `${PDFtype}_${getSystemFormattedTimestamp()}.xlsx`
    );
  };

  return (
    <>
      <Button variant="contained" onClick={() => setExportModalOpen(true)} color="primary">
        <PictureAsPdfIcon style={{ marginRight: 8 }} />
        Download
      </Button>
      <ExportFormatModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        onSelectPDF={handleDownload}
        onSelectExcel={handleExcelDownload}
      />
      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
        <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
      </Backdrop>
    </>
  );
};

export default DonationPDF;